/* eslint-disable i18next/no-literal-string */
import {
  Button,
  Icon,
  Image,
  OsStack,
  Paper,
  Skeleton,
  Typography,
} from "@outschool/backpack";
import { borderRadius } from "@outschool/backpack/dist-cjs/theme/borderRadius";
import {
  faChevronLeft,
  faDownload,
  faRepeat,
  faSparkles,
  faUser,
} from "@outschool/icons";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

// const SAVE_AVATAR_MUTATION = gql`
//   mutation SaveLearnerAvatar(
//     $cdnUrl: String!
//     $name: String!
//     $description: String!
//     $animals: [String!]!
//   ) {
//     saveAvatar(
//       cdnUrl: $cdnUrl
//       name: $name
//       description: $description
//       animals: $animals
//     )
//   }
// `;

interface AvatarResultProps {
  avatar: {
    name: string;
    description: string;
    imageUrl: string;
  };
  animals: string[];
  onBack: () => void;
}

export default function AvatarResult({
  avatar,
  animals,
  onBack,
}: AvatarResultProps) {
  const isMobile = useIsMobile();
  const imageWidth = isMobile ? 300 : 500;
  // TODO: update this from query
  const isImageLoading = true;
  const handleSave = async () => {
    console.log("Saving avatar", avatar);
    console.log("Animals", animals);
    // try {
    //   await saveAvatar({
    //     variables: {
    //       cdnUrl: avatar.imageUrl,
    //       name: avatar.name,
    //       description: avatar.description,
    //       animals,
    //     },
    //     refetchQueries: [getCurrentLearner],
    //   });
    //   setIsSaved(true);
    // } catch (err: any) {
    //   setSaveError(err.message || "Failed to save avatar");
    // } finally {
    //   setIsSaving(false);
    // }
  };

  const handleDownload = () => {
    // Open image in a new tab so user doesn't lose current page
    window.open(avatar.imageUrl, "_blank");
  };

  return (
    <OsStack spacing={{ xs: 2, md: 4 }}>
      <Button
        startIcon={<Icon icon={faChevronLeft} />}
        size="small"
        sx={{ width: "fit-content" }}
        onClick={onBack}
      >
        Back
      </Button>
      <Paper
        variant="elevation"
        sx={{
          borderRadius: borderRadius.medium,
          padding: { xs: "16px", md: "32px" },
        }}
      >
        <OsStack
          spacing={{ xs: 4, md: 6 }}
          direction="column"
          alignItems="center"
        >
          <OsStack spacing={{ xs: 2, md: 4 }} alignItems="center">
            <Typography variant="h1">
              <Icon icon={faSparkles} color="warning" /> {avatar.name}{" "}
              <Icon icon={faSparkles} color="warning" />
            </Typography>
            <Typography variant="body1">
              Your new creature is ready! {avatar.description}
            </Typography>
          </OsStack>
          {isImageLoading ? (
            <Skeleton
              variant="rectangular"
              width={imageWidth}
              height={imageWidth}
              sx={{ borderRadius: borderRadius.medium }}
            />
          ) : (
            <Image
              src={avatar.imageUrl}
              alt={avatar.name}
              width={imageWidth}
              height={imageWidth}
              borderRadius={borderRadius.medium}
            />
          )}
          <OsStack
            spacing={{ xs: 2, md: 4 }}
            direction={isMobile ? "column" : "row"}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              startIcon={<Icon icon={faUser} />}
            >
              Set as Profile Picture
            </Button>
            <Button
              variant="outlined"
              onClick={handleDownload}
              startIcon={<Icon icon={faDownload} />}
            >
              Download
            </Button>
            <Button
              variant="outlined"
              onClick={onBack}
              startIcon={<Icon icon={faRepeat} />}
            >
              Mix Again
            </Button>
          </OsStack>
        </OsStack>
      </Paper>
    </OsStack>
  );
}
